"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var flickity_1 = __importDefault(require("flickity"));
var CustomFlickityNavigation_1 = __importDefault(require("../helpers/CustomFlickityNavigation"));
var initSlider = function (root) {
    var previousBtn = root.querySelector('.Slider__nav .previous');
    var nextBtn = root.querySelector('.Slider__nav .next');
    var container = root.querySelector('.Slider__container');
    var flkty = new flickity_1.default(container, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        selectedAttraction: 0.15,
        friction: 0.8
    });
    if (nextBtn && previousBtn) {
        CustomFlickityNavigation_1.default(flkty, previousBtn, nextBtn);
    }
    return flkty;
};
exports.default = (function () {
    var slideContainers = Array.from(document.querySelectorAll('.Slider'));
    if (!slideContainers)
        return;
    slideContainers.map(initSlider);
});
